import { checkDirtyForm, setDirtyForm } from 'app/actions/dirty-forms.actions';
import confirmTemplate from './views/unsaved-changes-cancel-dialog.html';
/* REDUX */
const mapStateToThis = (state) => ({});

const mapDispatchToThis = {
  checkDirtyForm,
  setDirtyForm,
};

@Inject('$ngRedux', 'Notifications')
class CancelController {
  constructor() {
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, mapDispatchToThis)(this);
  }

  $onDestroy() {
    this.unsubscribe();
  }

  onClick() {
    const dirty = this.checkDirtyForm(this.formName);

    if (dirty) {
      this.Notifications.showSimpleDialog(confirmTemplate).result.then(() => {
        this.$ngRedux.dispatch(setDirtyForm(this.formName, false));
        // call action
        this.onClickHandler();
      });
    } else {
      this.onClickHandler();
    }
  }
}

export default class CancelButtonComponent {
  constructor() {
    this.controller = CancelController;
    this.template = '<span ng-click="$ctrl.onClick()" ng-transclude></span>';
    this.transclude = true;

    this.bindings = {
      formName: '<',
      onClickHandler: '&',
    };
    return this;
  }
}



// WEBPACK FOOTER //
// ./src/modules/utils/dirty-form/cancel-button-component.js